import React from 'react';
import { navigate } from '../services/navigation';

function Footer() {
  const handleNavigate = (path) => (event) => {
    event.preventDefault();
    navigate(path);
  };

  return (
    <footer className="footer">
      <div className="footer-links">
        <a className="footer-link" href="/terms" onClick={handleNavigate('/terms')}>
          Terms
        </a>
        <a className="footer-link" href="/privacy" onClick={handleNavigate('/privacy')}>
          Privacy
        </a>
        <a
          className="footer-link"
          href="/creator-policy"
          onClick={handleNavigate('/creator-policy')}
        >
          Creator Policy
        </a>
        <a
          className="footer-link"
          href="/content-rules"
          onClick={handleNavigate('/content-rules')}
        >
          Content Rules
        </a>
      </div>
      <p className="footer-copy">© Talkali</p>
    </footer>
  );
}

export default Footer;